import React, { StrictMode } from 'react';
import {
  Routes, Route, Navigate
} from 'react-router-dom';
import './App.css';
import Ballot from './Ballot';
import Standings from './Standings';
import {UserTable, CategoryTable} from './TableData';
import MasterBallot from './MasterBallot';

function App() {
  return (
    <StrictMode>
      <div>
        <Routes>
          <Route path="/standings" element={<Standings />} />
          <Route path="/ballot" element={<Ballot/>} />
          <Route path="/masterballot" element={<MasterBallot/>} />
          <Route path="/" element={
            <Navigate to="/ballot" />}/>
          {/* Redirect old /show path to /ballot */}
          <Route path="/show" element={
            <Navigate to="/ballot" />}/>
          <Route path="table">
          <Route path="user/:user" element={<UserTable />} />
          <Route path="category/:category" element={<CategoryTable />} />
          </Route>
        </Routes>
      </div>
    </StrictMode>
  );
}

export default App;
